import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { EmptyState } from '@/components/shared'
import { taskService } from '@/services/taskService'

// /browse/PC-42 — stable, shareable ticket links (like Jira's /browse/KEY).
const BrowseTask = () => {
  const { taskKey } = useParams()
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    taskService.getTaskByKey(taskKey)
      .then(res => {
        const task = res.data?.task
        if (!cancelled && task) navigate(`/projects/${task.project_id}/tasks/${task.id}`, { replace: true })
      })
      .catch(err => {
        if (!cancelled) setError(err.response?.data?.error || 'Task not found')
      })
    return () => { cancelled = true }
  }, [taskKey])

  if (error) {
    return (
      <EmptyState
        icon="search"
        title={`${taskKey} not found`}
        description="The ticket doesn't exist, or it is in a project you don't have access to."
        actionLabel="Go to projects"
        onAction={() => navigate('/projects')}
      />
    )
  }

  return (
    <div className="flex items-center justify-center py-24 text-muted-foreground gap-2">
      <Loader2 className="h-4 w-4 animate-spin" /> Opening {taskKey}…
    </div>
  )
}

export default BrowseTask
